import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "edit-circle",
  "use": "edit-circle-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"edit-circle\">\n  <circle fill-rule=\"evenodd\" cx=\"7\" cy=\"7\" r=\"7\" />\n  <path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M167.041,281.267a0.528,0.528,0,0,0,.692.692l1.934-.811-1.815-1.815Zm0,0,7.8-5.805-1.308-1.308a0.529,0.529,0,0,0-.747,0l-4.454,4.454,0,0,2.055,2.055,0,0,4.454-4.455a0.529,0.529,0,0,0,0-.747h0Zm0,0\" transform=\"translate(-164 -271)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/edit-circle.svg
// module id = null
// module chunks = 